import { Component } from 'react';
import styles from './PrivacyNoticePage.module.scss';

class PrivacyNoticePage extends Component {
    componentDidMount() {
        const mainContainer = document.createElement('div');
        mainContainer.className = styles['ot-privacy-notice-container'];

        if (!document.querySelector(`.${styles['ot-privacy-notice-container']}`)) {
            document.body.appendChild(mainContainer);
        }

        if (!document.querySelector('.ot-privacy-notice-language-dropdown-container')) {
            const dropdown = document.createElement('div');
            dropdown.className = 'ot-privacy-notice-language-dropdown-container';
            mainContainer.appendChild(dropdown);
        }

        if (!document.querySelector('#otnotice-bee62612-3846-42b6-bd3a-cb9c7577059c')) {
            const container = document.createElement('div');
            container.id = 'otnotice-bee62612-3846-42b6-bd3a-cb9c7577059c';
            container.className = 'otnotice';
            mainContainer.appendChild(container);
        }

        if (!document.querySelector('#otprivacy-notice-script')) {
            const script = document.createElement('script');
            script.src =
                'https://privacyportal-cdn.onetrust.com/privacy-notice-scripts/otnotice-1.0.min.js';
            script.type = 'text/javascript';
            script.charset = 'UTF-8';
            script.id = 'otprivacy-notice-script';
            script.setAttribute(
                'settings',
                'eyJjYWxsYmFja1VybCI6Imh0dHBzOi8vZ2xvYmFsZHNhci5zb2xlcmEuY29tL3JlcXVlc3QvdjEvcHJpdmFjeU5vdGljZXMvc3RhdHMvdmlld3MiLCJjb250ZW50QXBpVXJsIjoiaHR0cHM6Ly9nbG9iYWxkc2FyLnNvbGVyYS5jb20vcmVxdWVzdC92MS9lbnRlcnByaXNlcG9saWN5L2RpZ2l0YWxwb2xpY3kvY29udGVudCIsIm1ldGFkYXRhQXBpVXJsIjoiaHR0cHM6Ly9nbG9iYWxkc2FyLnNvbGVyYS5jb20vcmVxdWVzdC92MS9lbnRlcnByaXNlcG9saWN5L2RpZ2l0YWxwb2xpY3kvbWV0YS1kYXRhIn0=',
            );

            script.onload = () => {
                if (window.OneTrust?.NoticeApi?.Initialized) {
                    window.OneTrust.NoticeApi.Initialized.then(() => {
                        window.OneTrust.NoticeApi.LoadNotices([
                            'https://privacyportal-cdn.onetrust.com/storage-container/20bbc57b-6134-4535-8062-a1745b771851/privacy-notices/bee62612-3846-42b6-bd3a-cb9c7577059c/published/privacynotice.json',
                        ]);
                    });
                }
            };

            mainContainer.appendChild(script);
        }
    }

    componentWillUnmount() {
        const mainContainer = document.querySelector(`.${styles['ot-privacy-notice-container']}`);
        if (mainContainer) {
            mainContainer.remove();
        }
    }

    render() {
        return null;
    }
}

export default PrivacyNoticePage;
